
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import TableSortLabel from '@material-ui/core/TableSortLabel';

import { ListContext } from './ListProvider';


export default class TableListSort extends Component {

  ASC = 'asc';
  DESC = 'desc';

  static propTypes = {
    name: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired
  };

  render() {
    const { label, name } = this.props;
    return (
      <ListContext.Consumer>
        {context => {
          const type = context.getOrderField(name);
          return (
            <TableSortLabel
              active={type !== null}
              direction={type !== null ? type : this.ASC}
              onClick={() => context.setOrder(name, type)}
            >
              {label}
            </TableSortLabel>
          )
        }}
      </ListContext.Consumer>
    )
  }
}
